import React from "react";
import "./CardTVPlan.css";
import { Tv, Phone, CheckCircledOutline, Wifi, Cart, DataTransferBoth } from "iconoir-react";
import { calling } from "../FuntionCall/calling";

const CardTVPlan = (props) => {
  // Destructurar solo las props que necesitamos para el renderizado
  const {
    nombreplan = "",
    velocidad = "0",
    tipoTv = "basico",
    tipoplan = "",
    canales = null,
    precio = 0,
    precioDescuento = null,
    estrato = 1,
    estratoview = "1-3",
    funcion,
    nombreButton = "Adquirir Plan",
    Loader,
    campaing = false,
    descuento = null,
    meses = null,
    megas = 0,
    discount_months = null,
  } = props;

  // Determinar el tipo de plan para el estilo
  const planClass = tipoTv?.toLowerCase().replace(" ", "-") || "basico";

  // Información de canales según el tipo de TV
  const channelsInfo = {
    basico: { count: "27", name: "Básico", description: "TV Básico" },
    plata: { count: "60", name: "Plata", description: "TV Plata" },
    "plata plus": { count: "70", name: "Plata Plus", description: "TV Plata Plus" },
  };

  const tvInfoBase = channelsInfo[tipoTv?.toLowerCase()] || channelsInfo.basico;
  const tvInfo = {
    ...tvInfoBase,
    count: canales || tvInfoBase.count,
  };

  // Determinar el estrato mostrado
  const estratoDisplay = estratoview || (estrato <= 3 ? "1-3" : "4-6");

  // Formatear precio
  const formatPrice = (price) => {
    if (!price || isNaN(price)) return "$0";
    const formattedPrice = new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(Math.trunc(price));
    
    return formattedPrice.replace("COP", "$").replace(/\s/g, '');
  };

  const handleClick = () => {
    if (funcion && typeof funcion === 'function') {
      // Marcamos explícitamente que el evento viene de una tarjeta de TV
      funcion({ ...props, isTvCard: true });
    }
  };

  const handleContact = () => {
    // Llamar a la función calling para mostrar el modal de asesoría
    if (nombreplan) {
      calling(nombreplan);
    }
  };

  // Determinar características según el tipo de plan
  const getFeatures = () => {
    const baseFeatures = [
        "1 pantalla simultánea",
        "Canales nacionales",
        "Entretenimiento"
    ];
    
    if (tipoTv?.toLowerCase() === "plata") {
      return [
        "2 pantallas simultáneas",
        "Todo TV Básico",
        "Series y películas",
      ];
    }
    
    if (tipoTv?.toLowerCase() === "plata plus") {
      return [
        "2 pantallas simultáneas",
        "Todo TV Premium",
        "Deportes",
      ];
    }
    
    return baseFeatures;
  };

  // Renderizar megas adicionales si existen
  const megasadicionales = (megasExtra) => {
    const megasExtraNum = parseInt(megasExtra) || 0;
    const velocidadNum = parseInt(velocidad) || 0;
    const mesesNum = parseInt(meses) || 0;
    const discountMonthsNum = parseInt(discount_months) || 0;
    const showMegaMonths = discountMonthsNum > 0 && discountMonthsNum !== mesesNum;

    if (megasExtraNum > 0) {
      return (
        <div style={{ fontSize: "30px" }}>
          <b className="text-colorprimary inline-flex justify-center">
            {" "}
            {megasExtraNum + velocidadNum} Megas
            <DataTransferBoth style={{ width: "10%" }} />
          </b>
          <div style={{ marginBottom: "-0.9rem" }}></div>
          {showMegaMonths ? (
            <div style={{ marginBottom: "-1.5rem", marginTop: "-1.5rem" }}>
              <b style={{ fontSize: "12px", color: "#4a1272" }}>x{discountMonthsNum} meses</b>
            </div>
          ) : (
            <div style={{ marginBottom: "-1.5rem", marginTop: "-1.5rem", opacity: 0 }} aria-hidden="true">
              <b style={{ fontSize: "12px" }}>&nbsp;</b>
            </div>
          )}
          <div style={{ display: "inline-flex", marginTop: "-2rem" }}>
            <h6 className="presnorm"> {Math.trunc(velocidadNum)} Megas</h6>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className={`tv-plan-card ${planClass}`}>

    
      {/* Badge "NUEVO" */}
      <div className="tv-nuevo-badge">¡NUEVO!</div>
      
      {/* Header con fondo degradado */}
      <div className="tv-card-header">
        <div className="tv-icon-container">
          <Tv className="tv-header-icon" />
        </div>
        <h6 className="tv-plan-subtitle">Plan Residencial</h6>
        <h3 className="tv-plan-name">{tvInfo.description}</h3>
        <div className="tv-channels-badge">
          <div className="tv-channels-row">
            <span className="tv-channels-number">{tvInfo.count}</span>
            <span className="tv-channels-text">Canales</span>
          </div>
        </div>
      </div>

      {/* Body con fondo blanco */}
      <div className="tv-card-body">
        {/* Información de plan y precios - CON CAMPAÑA */}
        {campaing && descuento && precioDescuento ? (
          <div className="tv-price-container">
            <div>
              <div>
                {megas && parseInt(megas) > 0 ? (
                  megasadicionales(megas)
                ) : (
                  <div style={{ fontSize: "30px" }}>
                    <b className="text-colorprimary inline-flex justify-center">
                      {velocidad} Megas
                      <DataTransferBoth style={{ width: "10%" }} />
                    </b>
                    <div style={{ marginBottom: "-0.9rem" }}></div>
                    <div style={{ marginBottom: "-1.5rem", marginTop: "-1.5rem", opacity: 0 }} aria-hidden="true">
                      <b style={{ fontSize: "12px" }}>&nbsp;</b>
                    </div>
                    <div style={{ display: "inline-flex", marginTop: "-2rem", opacity: 0 }} aria-hidden="true">
                      <h6 className="presnorm">&nbsp;</h6>
                    </div>
                  </div>
                )}
              </div>
              
              {/* Estrato y Precio con descuento */}
              <div className="">
                <div className="text-2xl">
                  <h6>Estrato {estratoDisplay}</h6>
                  <b>
                    {formatPrice(precioDescuento)}
                  </b>{" "}
                  <b style={{ fontSize: "12px" }}>x{meses} meses</b>
                  <div className="valor card-title pricing-card-title">
                    <h5 className="opacity-50 line-through text-sm">
                      {formatPrice(precio)}
                    </h5>
                  </div>
                </div>
              </div>
              
              {/* Badge de descuento */}
              <div className="rounded-xl text-sm text-red-500 border-red-500 border-2 mx-4">
                <h3 className="text-sm m-1">
                  <b>{descuento}% dto online</b>
                </h3>
              </div>
            </div>
          </div>
        ) : (
          /* Información de plan y precios - SIN CAMPAÑA */
          <div className="tv-price-container">
            <div style={{ padding: "0" }}>
              <h2 style={{ fontSize: "30px" }}>
                <b className="text-colorprimary inline-flex justify-center">
                  {" "}
                  {velocidad} Megas
                  <DataTransferBoth style={{ width: "10%" }} />
                </b>
              </h2>
            </div>
            <div className="valor card-title pricing-card-title">
              <h6>Estrato {estratoDisplay}</h6>
              <br></br>
              <h5 style={{ fontSize: "22px" }}>
                <b>
                  {formatPrice(precio)}
                </b>
                <h6>Mensual</h6>
              </h5>
            </div>
          </div>
        )}

        {/* Incluye */}
        <div className="tv-features-section">
          <b className="tv-features-title">Incluye</b>
          <ul className="tv-features-list">
            {getFeatures().map((feature, index) => (
              <li key={index} className="tv-feature-item">
                <CheckCircledOutline className="tv-feature-check" />
                {feature}
              </li>
            ))}
            <li className="tv-feature-item">
              <Wifi className=" text-colorprimary size-4" />
              {velocidad} Megas
            </li>
          </ul>
        </div>

        {/* Botones */}
        <div className="tv-buttons-section">
          <button className="tv-action-button tv-primary" onClick={handleClick}>
            <Cart className="tv-button-icon-small" />
            {nombreButton}
          </button>
          <button className="tv-action-button tv-secondary" style={{ display: props.display }} onClick={handleContact}>
            <Phone className="tv-button-icon-small" />
            Te asesoramos
          </button>
        </div>
      </div>

      {/* Bloque oculto normativa CRC v4 - leído por el web scraper de la entidad reguladora */}
      <div
        className="plan pospago"
        dane="76001,76520,76892,76130,76364"
        titulo={nombreplan}
        valor-numerico={parseInt(precio)}
        estrato={estratoview === "1-3" ? "1,2,3" : "4,5,6"}
        style={{ display: "none" }}
      >
        <div className="operador" operador-nit="890399003">EMCALI</div>
        <div className="internet" tecnologia="108">
          <div>
            Internet de{" "}
            <span className="velocidad-bajada">
              {megas && parseInt(megas) > 0 ? parseInt(megas) + parseInt(velocidad) : velocidad}
            </span>{" "}
            Mbps de bajada
          </div>
          <div>
            Internet de{" "}
            <span className="velocidad-subida">
              {megas && parseInt(megas) > 0 ? parseInt(megas) + parseInt(velocidad) : velocidad}
            </span>{" "}
            Mbps de subida
          </div>
        </div>
        <div className="television" tecnologia="3">
          <span className="canales-hd">{tvInfo.count}</span> canales
        </div>
        {tipoplan === "Triple" && (
          <div className="telefonia">
            <span className="minutos-incluidos">ilimitados</span> minutos a destinos fijos locales
          </div>
        )}
        <img className="operador-logo" src="https://c748596267.imgdist.com/pub/bfra/zs95jvh4/uy4/tyz/u0a/logo_emcali.png" alt="EMCALI" />
        <div className="url-comercial">
          https://portalservicios.emcali.net.co/planes
        </div>
      </div>

      {Loader && <div className="loader-overlay">{Loader}</div>}
    </div>
  );
};

export default CardTVPlan;
